import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const VerifyOtp = () => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(30);
  const { user, verifyOtp, resendOtp } = useAuth();
  const navigate = useNavigate();

  // Redirect if already verified or not logged in
  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else if (user.phone_verified) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  // Resend cooldown timer
  useEffect(() => {
    if (resendCooldown <= 0) return;
    const timer = setTimeout(() => setResendCooldown(resendCooldown - 1), 1000);
    return () => clearTimeout(timer);
  }, [resendCooldown]);

  const maskedPhone = user?.phone
    ? '****' + user.phone.slice(-4)
    : '';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);
    try {
      await verifyOtp(otp);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setError('');
    setSuccess('');
    try {
      await resendOtp();
      setSuccess('OTP sent successfully.');
      setResendCooldown(30);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to resend OTP');
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-left">
        <div className="auth-brand">
          <img src="/logo.png" alt="Manthrakodi Matrimony" className="auth-brand-logo" />
        </div>
        <div className="auth-tagline">
          <h2>Verify your phone number</h2>
          <ul>
            <li>✓ Secure OTP verification</li>
            <li>✓ One-time password sent via SMS</li>
            <li>✓ Quick and easy</li>
          </ul>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
          <h2>OTP Verification</h2>
          <p className="auth-subtitle">
            Enter the 6-digit code sent to {maskedPhone}
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="otp-input">OTP Code</label>
              <input
                id="otp-input"
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                required
                autoFocus
              />
            </div>

            {error && <div className="error-msg">{error}</div>}
            {success && <div className="error-msg" style={{ color: '#27ae60', background: '#eafaf1' }}>{success}</div>}

            <button
              type="submit"
              className="btn-primary"
              disabled={loading || otp.length !== 6}
            >
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
          </form>

          <div className="auth-footer" style={{ marginTop: '1rem', textAlign: 'center' }}>
            <button
              type="button"
              onClick={handleResend}
              disabled={resendCooldown > 0}
              style={{
                background: 'none',
                border: 'none',
                color: resendCooldown > 0 ? '#999' : '#8b5cf6',
                cursor: resendCooldown > 0 ? 'default' : 'pointer',
                fontSize: '0.9rem',
              }}
            >
              {resendCooldown > 0
                ? `Resend OTP in ${resendCooldown}s`
                : 'Resend OTP'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOtp;
